"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseNumericValue = exports.isProd = exports.isServer = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var isServer = !(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.isServer = isServer;
var isProd = typeof window !== 'undefined' && (0, _typeof2.default)(window.location) && (0, _typeof2.default)(window.location.hostname) && window.location.hostname.replace(/^www\./i, '') === 'figure.com';
/**
 * A function that takes in a number in a string format, and parses it.
 * Mostly used with inputs that deal with numbers, but yield a string representation.
 *
 * @param {String} value
 *
 * @returns {Number} value converted to a Number, or undefined
 */

exports.isProd = isProd;

var parseNumericValue = function parseNumericValue(value) {
  var newValue = typeof value === 'number' ? value : Number.parseFloat(value);
  return Number.isNaN(newValue) ? undefined : newValue;
};

exports.parseNumericValue = parseNumericValue;